/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function PolyesterSmall(props) {
	const { nodes, materials } = useGLTF("models/polyster.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder002.geometry}
				material={materials["Metal Vent Slats"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder002_1.geometry}
				material={materials.Fabric}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder002_2.geometry}
				material={materials["Brushed metal"]}
			/>
		</group>
	);
}

useGLTF.preload("models/polyster.glb");
